<template>
  <div>
    <logged-in-header />
    <accesses-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import accessesPanel from "../components/access-control/AccessesPanel";

export default {
  components: {
    loggedInHeader,
    accessesPanel
  }
};
</script>
